import React, { createContext, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { GetRevenueSharingAPI, GoogleAnalyticAPI } from './../api-services/RevenueSharing.service';
import { localStorageKeys } from '../../utils/constants';

export const RevenueSharingContext = createContext();
const RevenueSharingDataProvider = ({ children }) => {
  const [revenueSharingAPIResponse, setRevenueSharingAPIResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const [googleAnalyticAPIResponse, setGoogleAnalyticAPIResponse] = useState({
    loading: false,
    success: null,
    message: null,
    data: null,
  });

  const { TOKEN } = localStorageKeys;
  const gettingToken = localStorage.getItem(TOKEN);

  const onRevenueSharingDataAPI = async (operationPayload) => {
    try {
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setRevenueSharingAPIResponse({
          success: false,
          loading: false,
          data: null,
          errorMessage: 'Token & Refresh Token missing',
        });
        return;
      }

      await setRevenueSharingAPIResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const payload = {
        ...operationPayload,
      };

      const data = await GetRevenueSharingAPI(payload);

      if (data.hasError) {
        await setRevenueSharingAPIResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return data;
      }

      if (data.data?.success) {
        await setRevenueSharingAPIResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });

        return data?.data;
      } else {
        await setRevenueSharingAPIResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      }
      return data?.data;
    } catch (error) {
      console.log('---Catch black onRevenueSharingDataAPI', error);
      setRevenueSharingAPIResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  const onGoogleAnalyticDataAPI = async (payload) => {
    try {
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setGoogleAnalyticAPIResponse({
          success: false,
          loading: false,
          data: null,
          errorMessage: 'Token & Refresh Token missing',
        });
        return;
      }

      await setGoogleAnalyticAPIResponse({
        loading: true,
        success: null,
        message: null,
        data: null,
      });

      const data = await GoogleAnalyticAPI(payload);

      if (data.hasError) {
        await setGoogleAnalyticAPIResponse({
          loading: false,
          data: null,
          success: !data.hasError,
          message: data.message,
        });
        return data;
      }

      if (data.data?.success) {
        await setGoogleAnalyticAPIResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.customMessage,
        });

        return data?.data;
      } else {
        await setGoogleAnalyticAPIResponse({
          loading: false,
          data: data,
          success: data.data?.success,
          message: data.data?.message,
        });
      }
      return data?.data;
    } catch (error) {
      console.log('---Catch black onGoogleAnalyticDataAPI', error);
      setGoogleAnalyticAPIResponse({ loading: false, data: null, success: false, message: error });
    }
  };

  return (
    <RevenueSharingContext.Provider
      value={{
        revenueSharingAPIResponse,
        setRevenueSharingAPIResponse,
        onRevenueSharingDataAPI,
        onGoogleAnalyticDataAPI,
        setGoogleAnalyticAPIResponse,
        googleAnalyticAPIResponse,
      }}
    >
      {children}
    </RevenueSharingContext.Provider>
  );
};

export default RevenueSharingDataProvider;
